var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('retailer-card',{attrs:{"advertiser":_vm.advertiserBrand,"retailers":_vm.retailers,"loading":!_vm.loaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }